/* ============================================================
   OMNIA FOOD TRADING — Main JavaScript
   ============================================================ */
(function () {
  'use strict';

  /* ── SCROLL REVEAL ── */
  const revealEls = document.querySelectorAll('.omnia-reveal');
  if (revealEls.length) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(el => obs.observe(el));
  }

  /* ── COUNTDOWN TIMER ── */
  document.querySelectorAll('[data-omnia-countdown]').forEach(el => {
    const end = el.dataset.omniaCountdown;
    let target = end ? new Date(end) : null;
    if (!target || isNaN(target)) {
      target = new Date(Date.now() + 24 * 3600000);
    }
    const tick = () => {
      const diff = target - Date.now();
      if (diff <= 0) { el.textContent = '00:00:00'; return; }
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      el.textContent =
        String(h).padStart(2,'0') + ':' +
        String(m).padStart(2,'0') + ':' +
        String(s).padStart(2,'0');
    };
    tick(); setInterval(tick, 1000);
  });

  /* ── CATEGORY NAV ACTIVE ── */
  document.querySelectorAll('.omnia-cat-item').forEach(item => {
    item.addEventListener('click', function () {
      document.querySelectorAll('.omnia-cat-item').forEach(i => i.classList.remove('active'));
      this.classList.add('active');
    });
  });

  /* ── FILTER GROUP TOGGLE ── */
  document.querySelectorAll('.omnia-filter-head').forEach(head => {
    head.addEventListener('click', function () {
      const group = this.closest('.omnia-filter-group');
      group.classList.toggle('open');
    });
  });

  /* ── FILTER CHECKBOXES ── */
  document.querySelectorAll('.omnia-filter-item').forEach(item => {
    item.addEventListener('click', function () {
      const check = this.querySelector('.omnia-check');
      if (check) check.classList.toggle('checked');
    });
  });

  /* ── ACTIVE FILTER CHIPS (remove on click) ── */
  document.querySelectorAll('.omnia-chip').forEach(chip => {
    chip.addEventListener('click', function () { this.remove(); });
  });

  /* ── FAQ PAGE: category switch ── */
  document.querySelectorAll('.omnia-faq-cat-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const target = this.dataset.target;
      document.querySelectorAll('.omnia-faq-cat-btn').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.omnia-faq-section').forEach(s => s.classList.remove('active'));
      this.classList.add('active');
      const sec = document.getElementById(target);
      if (sec) sec.classList.add('active');
    });
  });

  /* ── FAQ ACCORDION (page + product metafields) ── */
  document.querySelectorAll('.omnia-faq-q, .omnia-pf-q').forEach(q => {
    q.addEventListener('click', function () {
      const item = this.closest('.omnia-faq-item, .omnia-pf-item');
      if (!item) return;
      const isOpen = item.classList.contains('open');
      // close siblings in same container
      const container = item.parentElement;
      container.querySelectorAll('.omnia-faq-item, .omnia-pf-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ── SUBSCRIPTION OPTION SELECT ── */
  document.querySelectorAll('.omnia-sub-option').forEach(opt => {
    opt.addEventListener('click', function () {
      const wrap = this.closest('.omnia-sub-options');
      if (wrap) wrap.querySelectorAll('.omnia-sub-option').forEach(o => o.classList.remove('selected'));
      this.classList.add('selected');
    });
  });

  /* ── BLOG FILTER TAGS ── */
  document.querySelectorAll('.omnia-blog-tag').forEach(tag => {
    tag.addEventListener('click', function () {
      document.querySelectorAll('.omnia-blog-tag').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

  /* ── JUDGE.ME FILTER TABS ── */
  document.querySelectorAll('.omnia-jm-ftab').forEach(tab => {
    tab.addEventListener('click', function () {
      const wrap = this.closest('.omnia-jm-filter');
      if (wrap) wrap.querySelectorAll('.omnia-jm-ftab').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

  /* ── QTY BUTTONS ── */
  document.querySelectorAll('.omnia-qty-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const input = this.closest('.omnia-qty')?.querySelector('.omnia-qty-val');
      if (!input) return;
      const delta = this.dataset.action === 'minus' ? -1 : 1;
      const val = parseInt(input.value) || 1;
      input.value = Math.max(1, val + delta);
    });
  });

  /* ── NEWSLETTER FORM ── */
  document.querySelectorAll('.omnia-nl-form, .omnia-bn-form').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const btn = form.querySelector('.omnia-nl-btn, .omnia-bn-btn');
      const input = form.querySelector('input[type="email"]');
      if (!input?.value.trim()) return;
      if (btn) { btn.textContent = '✓ Subscribed!'; btn.style.background = '#16a34a'; }
      if (input) input.value = '';
      setTimeout(() => {
        if (btn) { btn.textContent = btn.dataset.label || 'Subscribe'; btn.style.background = ''; }
      }, 3000);
    });
  });

  /* ── SORT SELECT (collection) ── */
  const sortSel = document.querySelector('.omnia-sort-select');
  if (sortSel) {
    sortSel.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

})();

/* ── ADD TO CART (global) ── */
function omniaAddToCart(e, variantId, qty) {
  if(e) { e.preventDefault(); e.stopPropagation(); }
  if(!variantId) return;
  var btn = e ? e.currentTarget : null;
  if(btn) { btn.innerHTML = '...'; btn.disabled = true; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({id: variantId, quantity: qty || 1})
  })
  .then(function(r){ return r.json(); })
  .then(function(){
    if(btn) {
      var orig = btn.dataset.orig || btn.innerHTML;
      btn.dataset.orig = orig;
      btn.innerHTML = '✓';
      btn.style.background = '#16a34a';
      setTimeout(function(){ btn.innerHTML = orig; btn.style.background=''; btn.disabled=false; }, 1200);
    }
    // Open cart drawer then refresh
    if(typeof omniaCartDrawer === 'function') {
      omniaCartDrawer(true);
      // Force re-render after short delay to ensure items show
      setTimeout(function(){ if(typeof ocdRefresh === 'function') ocdRefresh(); }, 150);
    } else {
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
        document.querySelectorAll('.omnia-hdr-badge,.omnia-mhdr-badge,.omnia-m-nav-badge,.ocd-count').forEach(function(el){
          el.textContent = c.item_count;
          el.style.display = c.item_count > 0 ? 'flex' : 'none';
        });
      });
    }
  })
  .catch(function(){ if(btn){ btn.innerHTML = btn.dataset.orig || '+'; btn.disabled=false; } });
}

/* ── LANGUAGE SWITCHER (global) ── */
function omniaSwitchLang(lang, btn) {
  document.querySelectorAll('.omnia-lang-btn, .omnia-m-lang-btn').forEach(function(b) {
    b.classList.remove('active');
  });
  if (btn) btn.classList.add('active');

  // Use Shopify's native localization form - most reliable method
  var form = document.createElement('form');
  form.action  = '/localization';
  form.method  = 'POST';
  form.style.display = 'none';

  // CSRF token
  var csrf = document.querySelector('meta[name="csrf-token"]');
  if (csrf) {
    var t = document.createElement('input');
    t.name = 'authenticity_token';
    t.value = csrf.getAttribute('content');
    form.appendChild(t);
  }

  // PUT method override
  var m = document.createElement('input');
  m.name = '_method'; m.value = 'PUT';
  form.appendChild(m);

  // Locale
  var l = document.createElement('input');
  l.name = 'locale_code';
  l.value = lang === 'ar' ? 'ar' : 'en';
  form.appendChild(l);

  // Return to current page
  var r = document.createElement('input');
  r.name = 'return_to';
  r.value = window.location.pathname + window.location.search;
  form.appendChild(r);

  document.body.appendChild(form);
  form.submit();
}

/* ── CART DRAWER ── */
function omniaCartDrawer(open) {
  var drawer  = document.getElementById('ocd-drawer');
  var overlay = document.getElementById('ocd-overlay');
  if (!drawer) return;
  if (open) {
    try { if (typeof owdClose === 'function') owdClose(); } catch(e){}
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.classList.add('ocd-is-open');
    document.body.style.overflow = 'hidden';
    if (typeof ocdRefresh === 'function') ocdRefresh();
    setTimeout(function(){ if (typeof ocdRefresh === 'function') ocdRefresh(); }, 150);
  } else {
    drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.classList.remove('ocd-is-open');
    document.body.style.overflow = '';
  }
}

// Close on Escape
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') omniaCartDrawer(false);
});

/* ── CART DRAWER FUNCTIONS ── */
function ocdMoney(cents) {
  return 'AED ' + (cents / 100).toFixed(2);
}

function ocdShowLoading(show) {
  var el = document.getElementById('ocd-loading');
  if (el) el.classList.toggle('show', show);
}

function ocdQty(key, qty) {
  qty = Math.max(0, parseInt(qty));
  ocdShowLoading(true);
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({id: key, quantity: qty})
  })
  .then(function(r){ return r.json(); })
  .then(function(){ ocdRefresh(); })
  .catch(function(){ ocdShowLoading(false); });
}

function ocdAddItem(variantId, btn) {
  if (btn) { btn.disabled = true; btn.textContent = '...'; }
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({id: variantId, quantity: 1})
  })
  .then(function(r){ return r.json(); })
  .then(function(){
    if (btn) { btn.textContent = '✓'; btn.classList.add('done'); }
    ocdRefresh();
    if (btn) setTimeout(function(){ btn.textContent = '+'; btn.classList.remove('done'); btn.disabled = false; }, 1500);
  })
  .catch(function(){ if (btn) { btn.textContent = '+'; btn.disabled = false; } });
}

function ocdRefresh() {
  ocdShowLoading(true);
  fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(cart) {
      // Update badges
      document.querySelectorAll('.omnia-hdr-badge,.omnia-mhdr-badge,.omnia-m-nav-badge,.ocd-count').forEach(function(el){
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });

      // Shipping bar
      var threshold = 50000;
      var remaining = threshold - cart.total_price;
      var shipBar = document.getElementById('ocd-ship-bar');
      var isAr = document.documentElement.lang && document.documentElement.lang.startsWith('ar');
      if (shipBar) {
        var msg = isAr
          ? '🚚 توصيل مجاني ٢-٣ أيام · توصيل سريع ٢٤ ساعة بـ ٣٠ درهم فقط ⚡'
          : '🚚 Free delivery 2-3 days · Express 24h = AED 30 ⚡';
        shipBar.innerHTML = '<div class="ocd-ship-done">' + msg + '</div>';
      }

      var bodyEl   = document.getElementById('ocd-items');
      var emptyEl  = document.getElementById('ocd-empty');
      var footerEl = document.getElementById('ocd-footer');

      if (cart.item_count === 0) {
        if (bodyEl)   bodyEl.innerHTML = '';
        if (emptyEl)  emptyEl.style.display = 'flex';
        if (footerEl) { footerEl.style.display = 'block'; footerEl.style.opacity = '0.4'; footerEl.style.pointerEvents = 'none'; }
        ocdShowLoading(false);
        return;
      }

      if (emptyEl)  emptyEl.style.display  = 'none';
      if (footerEl) { footerEl.style.display = 'block'; footerEl.style.opacity = '1'; footerEl.style.pointerEvents = ''; }

      // Build items HTML
      var html = '';
      cart.items.forEach(function(item) {
        var img = item.image
          ? '<img src="' + item.image + '" alt="" style="width:100%;height:100%;object-fit:cover">'
          : '<div style="font-size:28px;display:flex;align-items:center;justify-content:center;height:100%">🛒</div>';

        var oldP = item.original_line_price !== item.final_line_price
          ? '<div class="ocd-price-old">' + ocdMoney(item.original_line_price) + '</div>' : '';

        var title = item.product_title.length > 45 ? item.product_title.substr(0,45) + '...' : item.product_title;
        var varT  = (item.variant_title && item.variant_title !== 'Default Title')
          ? '<div class="ocd-item-var">' + item.variant_title + '</div>' : '';

        var k = item.key;
        var q = item.quantity;

        html +=
          '<div class="ocd-item">' +
            '<a href="' + item.url + '" onclick="omniaCartDrawer(false)" class="ocd-item-img">' + img + '</a>' +
            '<div class="ocd-item-info">' +
              '<div class="ocd-item-brand">' + (item.vendor || '') + '</div>' +
              '<a href="' + item.url + '" onclick="omniaCartDrawer(false)" class="ocd-item-name">' + title + '</a>' +
              varT +
              '<div class="ocd-item-row">' +
                '<div class="ocd-qty">' +
                  '<button type="button" class="ocd-qty-btn" onclick="ocdQty(\'' + k + '\',' + (q-1) + ')">−</button>' +
                  '<span class="ocd-qty-val">' + q + '</span>' +
                  '<button type="button" class="ocd-qty-btn" onclick="ocdQty(\'' + k + '\',' + (q+1) + ')">+</button>' +
                '</div>' +
                '<button type="button" class="ocd-remove" onclick="ocdQty(\'' + k + '\',0)">' +
                  '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/></svg>' +
                '</button>' +
              '</div>' +
            '</div>' +
            '<div class="ocd-item-price">' + oldP + '<div class="ocd-price-now">' + ocdMoney(item.final_line_price) + '</div></div>' +
          '</div>';
      });

      if (bodyEl) bodyEl.innerHTML = html;

      var sub = document.getElementById('ocd-subtotal');
      if (sub) sub.textContent = ocdMoney(cart.total_price);

      ocdShowLoading(false);
    })
    .catch(function(){ ocdShowLoading(false); });
}

/* ── WISHLIST SYSTEM ── */
var OMNIA_WL_KEY = 'omnia_wishlist';

function omniaWishGet() {
  try { return JSON.parse(localStorage.getItem(OMNIA_WL_KEY) || '[]'); }
  catch(e) { return []; }
}

function omniaWishSave(list) {
  localStorage.setItem(OMNIA_WL_KEY, JSON.stringify(list));
}

function omniaWishHas(handle) {
  return omniaWishGet().indexOf(handle) > -1;
}

function omniaWishToggle(handle, btn) {
  var list = omniaWishGet();
  var idx  = list.indexOf(handle);
  if (idx > -1) {
    list.splice(idx, 1);
  } else {
    list.push(handle);
    // Open drawer when adding
    if (typeof owdOpen === 'function') owdOpen();
  }
  omniaWishSave(list);
  omniaWishUpdateBtn(handle, btn);
  omniaWishUpdateBadges();
}

function omniaWishUpdateBtn(handle, btn) {
  if (!btn) return;
  var inList = omniaWishHas(handle);
  btn.classList.toggle('wished', inList);
  btn.setAttribute('aria-pressed', String(inList));
}

function omniaWishUpdateBadges() {
  var count = omniaWishGet().length;
  document.querySelectorAll('.omnia-wish-badge').forEach(function(el) {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

// Init all wishlist buttons on page load
document.addEventListener('DOMContentLoaded', function() {
  omniaWishUpdateBadges();
  document.querySelectorAll('[data-wish-handle]').forEach(function(btn) {
    var handle = btn.getAttribute('data-wish-handle');
    omniaWishUpdateBtn(handle, btn);
  });
});

/* ── WISHLIST DRAWER (global open/close) ── */
function owdOpen() {
  // Close cart if open
  try { omniaCartDrawer(false); } catch(e){}
  var drawer  = document.getElementById('owd-drawer');
  var overlay = document.getElementById('owd-overlay');
  if (!drawer) { console.warn('Wishlist drawer not found — add {% render omnia-wishlist-drawer %} to theme.liquid'); return; }
  drawer.classList.add('open');
  if (overlay) overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  if (typeof owdRender === 'function') owdRender();
}

function owdClose() {
  var drawer  = document.getElementById('owd-drawer');
  var overlay = document.getElementById('owd-overlay');
  if (drawer)  drawer.classList.remove('open');
  if (overlay) overlay.classList.remove('open');
  document.body.style.overflow = '';
}

/* ── PAGE TRANSITIONS — prevent flash ── */
(function(){
  // Fade out on navigation
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href || href.startsWith('#') || href.startsWith('javascript') ||
        href.startsWith('mailto') || href.startsWith('tel') ||
        link.target === '_blank' || e.ctrlKey || e.metaKey || e.shiftKey) return;
    e.preventDefault();
    document.documentElement.style.opacity = '0';
    document.documentElement.style.transition = 'opacity .15s ease';
    setTimeout(function(){ window.location.href = href; }, 150);
  });

  // Clear service worker caches on load
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(function(regs){
      regs.forEach(function(r){ r.unregister(); });
    });
  }
})();
